export {
  handleChunkLoadError,
  type HandleChunkLoadErrorOptions,
} from './handle-chunk-load-error';
